import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: 'cssUrl',
    standalone: false
})
export class CssUrlPipe implements PipeTransform {
    transform(value) {
        return `url('${value}')`;
    }
}